import React from "react";
import { Link } from "react-router-dom";
import Breadcrumbs from "../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../Accordion/Accordion.js";
import data from "../Data/education/educationData.json";
import useSEO from "../hooks/useSEO.js";
import seoConfig from "../hooks/seoConfig.js";

export default function Education() {
  useSEO(seoConfig.education);

  return (
    <section className="contacts education">
      <Breadcrumbs />

      <h1 className="contacts__title history__title licenses__title">
        Образование
      </h1>

      <Accordion data={data} />

      <div className="footer__middle_block">
        <Link to="/education/residency" className="footer__link">
          Ординатура
        </Link>
        <Link to="/education/postgraduate-studies" className="footer__link">
          Аспирантура
        </Link>
        <Link to="/education/additional" className="footer__link">
          Дополнительное профессиональное образование
        </Link>
        <Link to="/education/teaching-staff" className="footer__link">
          Профессорско-преподавательский состав
        </Link>
        <Link to="/education/admissions-committee" className="footer__link">
          Приемная комиссия
        </Link>
        <Link to="/education/tax-deduction" className="footer__link">
          Налоговый вычет за платные образовательные услуги
        </Link>
      </div>
    </section>
  );
}
